<template>

    <div>
        <div v-if="!fullscreen" class="row text-center">
            <div class="col-12">

                <div class="card card-bordered card-full">
                    <div class="nk-wg1 link-block">
                        <div class="nk-wg1-block d-flex justify-content-center">
                            <div class="nk-wg1-text">
                                <h5 class="title">{{ translations.page_title }}</h5>
                                <button class="btn btn-success" @click="toggle">{{ translations.open_application }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- TODO: find something to hide all the content of the full-screen when not in full-screen mode -->
        <div class="fullscreen-wrapper" style="overflow-y: scroll;">
            <div id="full-screen-content" class="d-none">

                <div class="nk-header">
                    <div class="container-lg">
                        <div class="nk-header-wrap">
                            <div class="nk-header-brand">
                                {{ translations.page_title }}
                            </div>

                            <div class="nk-header-tools">
                                <button class="btn btn-secondary" @click="toggle">{{ translations.close_application }}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- full-screen body -->
                <div class="nk-content">
                    <div class="container wide-xxl">
                        <div class="nk-content-inner">
                            <div class="nk-content-body">
                                <div class="nk-content-wrap">

                                    <div class="row">
                                        <div class="col-lg-9">
                                            <div class="card card-bordered">
                                                <div class="nk-iv-wg4">

                                                    <div class="row gy-gs pb-3">
                                                        <div v-for="article in articles" class="col-sm-3">
                                                            <div class="card card-bordered product-card">
                                                                <div v-if="article.article.media" class="product-thumb">
                                                                    <img class="card-img-top" :src="article.article.media[0].original_url" :alt="article.article.media[0].name" style="height: 250px;object-fit: cover;">
                                                                </div>
                                                                <div class="card-inner text-center">
                                                                    <h5 class="product-title">
                                                                        {{ article.article.name }}
                                                                    </h5>
                                                                    <div class="product-price h5">
                                                                        <em class="fas fa-ticket-alt"></em> {{ article.tickets_price }} <br>
                                                                        <small><em class="fas fa-coins"></em> <span v-html="formatPrice(article.sale_price)"></span></small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3">
                                            <div class="card card-bordered sticky-top ml-lg-4 ml-xl-0">

                                                <div class="nk-iv-wg4">
                                                    <div class="nk-iv-wg4-sub">
                                                        <h6 class="nk-iv-wg4-title title">Overview</h6>
                                                    </div>
                                                    <div class="nk-iv-wg4-sub">
                                                        <ul class="nk-iv-wg4-list">
                                                            <li>
                                                                <div class="sub-text">Coca-cola</div>
                                                                <div class="lead-text" v-html="formatPrice(22.55)"></div>
                                                                <div class="sub-text"><em class="fas fa-trash-alt"></em></div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="nk-iv-wg4-sub">
                                                        <ul class="nk-iv-wg4-list">
                                                            <li>
                                                                <div class="lead-text">Total</div>
                                                                <div class="caption-text text-primary" v-html="formatPrice(22.55)"></div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="nk-iv-wg4-sub text-center bg-lighter">
                                                        <button
                                                            class="btn btn-lg btn-primary ttu"
                                                            @click="processPayment($event)">
                                                            <span class="spinner-border spinner-border-sm d-none" role="status" aria-hidden="true"></span>
                                                            <span>Confirm</span>
                                                        </button>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import {api as fullscreen} from 'vue-fullscreen'

export default {
    name: 'dotCash',

    props: [
        'event',
        'translations',
        'articles',
    ],

    data() {
        return {
            fullscreen: false,
            teleport: false,
        }
    },

    mounted() {
        let app = this;
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && app.fullscreen) {
                app.fullscreen = !app.fullscreen;
            }
        })
    },

    computed: {
    },

    methods: {
        /**
         * Toggles the full-screen
         * @returns {Promise<void>}
         */
        async toggle () {
            await fullscreen.toggle(this.$el.querySelector('.fullscreen-wrapper'), {
                teleport: this.teleport,
                callback: (isFullscreen) => {
                    if (isFullscreen) {
                        $('#full-screen-content').removeClass('d-none');
                    } else {
                        $('#full-screen-content').addClass('d-none');
                    }
                },
            })
            this.fullscreen = !this.fullscreen;
        },

        processPayment() {
            //
        },

        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',')

            return '&euro; ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
    }
}
</script>

<style scoped>
.nk-iv-wg4-sub {
    padding: 1.25rem 1.5rem;
}
.nk-iv-wg4-title {
    margin-bottom: 0.75rem;
}
h5, .h5, h6, .h6 {
    letter-spacing: -0.01em;
}

.g-2:not(.row) {
    margin: -0.375rem;
}
.g-2:not(.row) {
    margin: -0.375rem;
}
.nk-iv-wg4-overview {
    display: flex;
    flex-wrap: wrap;
}
.g-2:not(.row)>li, .g-2:not(.row)>div {
    padding: 0.375rem;
}
.nk-iv-wg4-sub:not(:last-child) {
    border-bottom: 1px solid #e5e9f2;
}
.nk-iv-wg4-sub {
    padding: 1.25rem 1.5rem;
}
ol, ul {
    list-style: none;
    margin: 0;
    padding: 0;
}
.nk-iv-wg4-list li {
    display: flex;
    justify-content: space-between;
}
li {
    list-style: none;
}
.sub-text {
    display: block;
    font-size: 13px;
    color: #8094ae;
}
.nk-iv-wg4 .lead-text {
    font-weight: 400;
}
.lead-text {
    font-size: .875rem;
    font-weight: 700;
    color: #364a63;
    display: block;
}

</style>
